import React from 'react';
import { ModalBody, ModalHeader, ModalFooter } from '../../Modal/Modal'
import Button from '../../Button/Button'
import ButtonGroup from '../../Button/ButtonGroup/ButtonGroup'
import { sanitizeData } from '../../JsonRTE/SuperChargedRte/components/Discussion/utils'

const NotifyOnChangeModal = (props: any): JSX.Element => {
    const closeModalHandler = (): void => {
        props.handleSubmit(false);
        props.closeModal()
     }
    return (
        <div>
            <ModalHeader
                title={<div className="flex-v-center"><span>{props.data.title}</span></div>}
                closeModal={closeModalHandler}
            />
            <ModalBody>
                <div className="delete-rule-msg" dangerouslySetInnerHTML={{ __html: sanitizeData(props.data.description) }}></div>
            </ModalBody>
            <ModalFooter>
                <ButtonGroup>
                    <Button
                        version='v2'
                        aria-label="Cancel"
                        type="button"
                        buttonType='tertiary'
                        testId="cs-cb-change-notify-cancel"
                        onClick={closeModalHandler}
                    >
                        <span>Cancel</span>
                    </Button>
                    <Button version='v2' aria-label="Yes" testId="cs-cb-change-notify" buttonType="secondary" icon="v2-Save" onClick={(): void => {
                        props.handleSubmit(true);
                        props.closeModal();
                    }}>
                        <span>Yes</span>
                    </Button>
                </ButtonGroup>
            </ModalFooter>
        </div>
    )
}

export default NotifyOnChangeModal;
